import { Form, Formik, FormikProps } from "formik"
import { IHttpErrorResponseModel, IPersonnelDocumentModel } from "@common-models/*"
import { toast } from "react-toastify"
import { AxiosError } from "axios"
import {
     CONST_CIVILITE_MR,
     CONST_CIVILITE_NON_RENSEIGNEE,
     CONST_CIVILITES_OPTIONS_FOR_SELECT2,
     CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR,
     CONST_PAYS_CODE_FRANCE,
     CONST_PAYS_ID_FRANCE,
     CONST_PERSONNEL_CONTRATS_OPTIONS_FOR_SELECT2,
     CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_ECOLE,
     CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_TT,
     CONST_PERSONNEL_STATUTS_OPTIONS_FOR_SELECT2,
     CONST_USER_ROLE_DAF,
     CONST_USER_ROLE_RESPONSABLE_RH,
     CONST_USER_ROLE_RH,
     CONST_FOURNISSEUR_FORMES_JURIDIQUE_OPTIONS_FOR_SELECT2,
     CONST_FOURNISSEUR_TYPES_OPTIONS_FOR_SELECT2,
     CONST_PERSONNEL_DOCUMENT_TYPE_CV,
     CONST_PERSONNEL_DOCUMENT_TYPE_PASSEPORT_CNI,
     CONST_PERSONNEL_DOCUMENT_TYPE_ATTESTATION_SS,
} from "@common-constants/*"
import * as Yup from "yup"
import MyAlert from "@common-utils/MyAlert"
import MyCard from "@common-utils/MyCard"
import MySimpleSpinner from "@common-utils/MySimpleSpinner"
import MyInputFormField from "@common-components/fields/MyInputFormField"
import MyInputMaskFormField from "@common-components/fields/MyInputMaskFormField"
import MySelectFormField from "@common-components/fields/MySelectFormField"
import MySelectGetAllDataFromServerFormField from "@common-components/fields/MySelectGetAllDataFromServerFormField"
import MySelectSearchDataFromServerFormField from "@common-components/fields/MySelectSearchDataFromServerFormField"
import MyDateDayMonthYearFormField from "@common-components/fields/MyDateDayMonthYearFormField"
import MyCheckboxFormField from "@common-components/fields/MyCheckboxFormField"
import React from "react"
import { IPersonnelDEFormModel, IPersonnelDEInfoPersoRequestModel, IPersonnelDEPosteRequestModel, IPersonnelDETempsRequestModel, IPersonnelDEFournisseurRequestModel, IPersonnelDemandeEmbaucheModel } from "../core/_models"
import { personnelDEStartRequest, personnelDESetInfoPersoRequest, personnelDESetPosteRequest, personnelDESetTempsRequest, personnelDESetFournisseurRequest, personnelDEGetDetailsRequest, personnelDESoumettreRequest, personnelDEAddDocumentRequest, personnelExtractIdentityDocumentRequest, IPersonnelIdentityExtractionModel } from "../core/_requests"
import { formatNom, formatPrenom } from "../core/_nameFormat"
import Swal from "sweetalert2"
import { useNavigate, useParams } from "react-router-dom"
import { useAuth } from "../../../AppContext"
import {
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE,
     ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_DEMANDE_EMBAUCHE_EDITER,
} from "../../gestion/routing/routing-endpoints"
import {
     CONST_API_UTILS_GET_ACTIVE_PERSONNELS_ENDPOINT,
     CONST_API_UTILS_GET_AGENCES_ENDPOINT,
     CONST_API_UTILS_GET_ENTITES_ENDPOINT,
     CONST_API_UTILS_GET_FOURNISSEURS_ENDPOINT,
     CONST_API_UTILS_GET_FOURNISSEURS_RESP_ENDPOINT,
     CONST_API_UTILS_GET_INDICATIF_TEL_ENDPOINT,
     CONST_API_UTILS_GET_METIERS_PERSONNEL_INTERNE_URL_ENDPOINT,
     CONST_API_UTILS_GET_PAYS_ENDPOINT,
     CONST_API_UTILS_GET_VILLES_URL_ENDPOINT,
} from "../../../endpoints"
import moment from "moment/moment"
import { PageTitle } from "@common-metronic/layout/core"
import { toAbsoluteUrl } from "@common-metronic/helpers"
import { driveImageUrl } from "../core/_avatar"
import MyModal from "@common-utils/MyModal"
import { getFournisseurSimpleDetails } from "../../fournisseur/core/_requests"
import AddFournisseurForm from "../../utils/core/_AddFournisseurForm"
import AddResponsableFournisseurForm from "../../utils/_AddResponsableFournisseurForm"
import DocumentsStep from "./_DocumentsStep"
import CenteredLoader from "../demandeEmbauche/_CenteredLoader"
import { ROUTING_BREADCRUMBS_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE } from "../../gestion/routing/routing-breadcrumbs"

// Clés d'étape (miroir des STEP_* backend) — l'enchaînement dépend de salarié / non salarié.
const STEP_KEY_INFO = "STEP_INFO_PERSO"
const STEP_KEY_FOURNISSEUR = "STEP_FOURNISSEUR"
const STEP_KEY_POSTE = "STEP_POSTE"
const STEP_KEY_TEMPS = "STEP_TEMPS"
const STEP_KEY_DOCS = "STEP_DOCUMENTS"

// Documents d'identité (salarié) dont l'upload en étape 1 déclenche un préremplissage IA des champs vides.
const IDENTITY_EXTRACTION_SLOTS: { type: string; label: string; hint: string; icon: string }[] = [
     { type: CONST_PERSONNEL_DOCUMENT_TYPE_ATTESTATION_SS, label: "Attestation de Sécurité Sociale", hint: "N° de sécurité sociale", icon: "fas fa-shield-halved" },
     { type: CONST_PERSONNEL_DOCUMENT_TYPE_PASSEPORT_CNI, label: "Passeport / Carte d'identité", hint: "Civilité, nom, prénom, nationalité", icon: "fas fa-passport" },
     { type: CONST_PERSONNEL_DOCUMENT_TYPE_CV, label: "Curriculum (CV)", hint: "Adresse, ville et code postal de résidence", icon: "fas fa-file-lines" },
]

type WizardStep = { key: string; title: string; icon: string; fields: (keyof IPersonnelDEFormModel)[] }

const IDENTITE_FIELDS_COMMUNES: (keyof IPersonnelDEFormModel)[] = [
     "civilite", "prenom", "nom", "emailPro", "telProIndicatif", "telPro", "mailPersonnel", "telPersonnelIndicatif", "telPersonnel",
]
const IDENTITE_FIELDS_SALARIE: (keyof IPersonnelDEFormModel)[] = [
     ...IDENTITE_FIELDS_COMMUNES,
     "dateNaissance", "nSecuriteSociale", "paysNaissance", "villeNaissance", "nationalite",
     "residenceAdresse", "residencePays", "residenceVilleFrance", "residenceVille", "residenceCodePostal",
]

// Construit la liste d'étapes selon le type de collaborateur.
// Salarié : Identité → Poste → Temps → Documents.
// Non salarié : Identité (réduite) → Fournisseur → Poste → Documents (pas d'étape Temps).
function buildSteps(estSalarie: boolean): WizardStep[] {
     // Non salarié : le fournisseur (+ son responsable + ses détails) est saisi dans la première étape, avant le collaborateur.
     const identite: WizardStep = {
          key: STEP_KEY_INFO,
          title: estSalarie ? "Identité & contact" : "Fournisseur & collaborateur",
          icon: estSalarie ? "fas fa-user" : "fas fa-building",
          fields: estSalarie ? IDENTITE_FIELDS_SALARIE : [...IDENTITE_FIELDS_COMMUNES, "fournisseur", "fournisseurResponsable"],
     }
     const poste: WizardStep = {
          key: STEP_KEY_POSTE,
          title: "Poste & organisation",
          icon: "fas fa-briefcase",
          fields: estSalarie
               ? ["statut", "contrat", "poste", "agence", "entite", "entiteFacturation", "responsable", "dateEntree", "linkedinUrl", "salaireBrutMensuel"]
               : ["poste", "agence", "entite", "entiteFacturation", "responsable", "dateEntree", "linkedinUrl", "tauxJournalierHt"],
     }
     const temps: WizardStep = { key: STEP_KEY_TEMPS, title: "Temps & activité", icon: "fas fa-clock", fields: ["heuresTravail", "heuresSupp"] }
     const documents: WizardStep = { key: STEP_KEY_DOCS, title: "Documents", icon: "fas fa-folder-open", fields: [] }
     return estSalarie ? [identite, poste, temps, documents] : [identite, poste, documents]
}

const MASK_DIGIT = /\d/
// Masque du N° de sécurité sociale (15 chiffres). Utilisé par le champ ET pour formater une valeur extraite par IA.
const MASK_SECU = "_ __ __ __ ___ ___ __"

// Applique un masque « _ » (chiffre) + littéraux à une chaîne de chiffres — reproduit le rendu de useMask
// pour qu'une valeur posée par programme (extraction IA) s'affiche comme une saisie manuelle.
const formatWithMask = (raw: string | undefined, mask: string): string => {
     const digits = (raw ?? "").replace(/\D/g, "")
     let out = ""
     let di = 0
     for (const ch of mask) {
          if (di >= digits.length) break
          if (ch === "_") out += digits[di++]
          else out += ch
     }
     return out
}

// Libellé avec astérisque « requis » manuel : pour les champs requis conditionnellement (`.when()`),
// que le marqueur automatique (isFieldRequired) ne détecte pas.
const requiredLabel = (text: string) => (
     <>
          {text} <span className="text-danger">*</span>
     </>
)

// Retire les accents/diacritiques (é -> e, ç -> c, …) — les adresses email ne doivent pas en contenir.
const stripAccents = (s?: string): string => (s ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "")

// Normalise une partie d'adresse email : sans accents + minuscules + espaces -> tirets (ex: "Émilie Le" -> "emilie-le")
const toEmailPart = (s?: string): string => stripAccents(s).toLowerCase().trim().replace(/\s+/g, "-")

// Statut « non salarié » (miroir backend Personnel::STATUT_NON_SALARIE).
const STATUT_NON_SALARIE = "STATUT_NON_SALARIE"
// Contrat « non salarié » (miroir backend Personnel::CONTRAT_NON_SALARIE) — exclu des options salarié.
const CONTRAT_NON_SALARIE_VALUE = "CONTRAT_NON_SALARIE"
// Contrat « alternance » (miroir backend Personnel::CONTRAT_ALTERNANCE) — présélectionne « École » dans les options CRA.
const CONTRAT_ALTERNANCE_VALUE = "CONTRAT_ALTERNANCE"

// Effet : quand le contrat passe à « Alternance », présélectionne « École » dans les options CRA (par défaut, modifiable ensuite).
const AlternanceCraDefaultEffect = ({ contrat, optionLignesCra, setFieldValue }: { contrat?: string; optionLignesCra?: string[]; setFieldValue: (field: string, value: any) => void }) => {
     React.useEffect(() => {
          if (contrat === CONTRAT_ALTERNANCE_VALUE && !(optionLignesCra ?? []).includes(CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_ECOLE)) {
               setFieldValue("optionLignesCra", [...(optionLignesCra ?? []), CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_ECOLE])
          }
          // eslint-disable-next-line react-hooks/exhaustive-deps
     }, [contrat])
     return null
}

// Catégorie de métier « commerciale » : le lien LinkedIn devient obligatoire (remplace la carte de visite via NFC).
const CATEGORIE_COMMERCIAL = "CATEGORIE_COMMERCIAL"

// Reprise : reconstruit les valeurs Formik à partir d'une demande existante (ids des relations pour les selects).
function buildPrefillFromDemande(d: IPersonnelDemandeEmbaucheModel): IPersonnelDEFormModel {
     const p = d.personnel
     // Champs staff DE récents pas encore typés dans IPersonnelModel (sérialisés côté back) : accès souple.
     const px = (p ?? {}) as any
     return {
          estSalarie: px?.statut !== STATUT_NON_SALARIE,
          entiteFacturation: px?.entiteFacturation?.id,
          salaireBrutMensuel: px?.salaireBrutMensuel ?? undefined,
          tauxJournalierHt: px?.tauxJournalierHt ?? undefined,
          fournisseur: px?.fournisseur?.id,
          fournisseurResponsable: px?.fournisseurResponsable?.id,
          type: px?.fournisseur?.type,
          formeJuridique: px?.fournisseur?.formeJuridique,
          raisonSociale: px?.fournisseur?.raisonSociale,
          siret: px?.fournisseur?.siret,
          adresse: px?.fournisseur?.adresse,
          ville: px?.fournisseur?.ville,
          codePostal: px?.fournisseur?.codePostal,
          pays: px?.fournisseur?.pays?.id,
          civilite: p?.civilite,
          prenom: formatPrenom(p?.prenom),
          nom: formatNom(p?.nom),
          emailPro: p?.mailProfessionnel,
          telProIndicatif: p?.telProfessionnelIndicatif?.id,
          telPro: p?.telProfessionnel,
          mailPersonnel: p?.mailPersonnel,
          telPersonnelIndicatif: p?.telPersonnelIndicatif?.id,
          telPersonnel: p?.telPersonnel,
          dateNaissance: p?.dateNaissance ? moment(p.dateNaissance).format("YYYY-MM-DD") : undefined,
          nSecuriteSociale: p?.nSecuriteSociale,
          paysNaissance: p?.paysNaissance?.id,
          villeNaissance: p?.villeNaissance,
          isNationaliteEtrangere: p?.isNationaliteEtrangere ?? false,
          nationalite: p?.nationalite?.id,
          residenceAdresse: p?.residenceAdresse,
          residencePays: p?.residencePays?.id,
          residenceVilleFrance: p?.residenceVilleFrance?.id,
          residenceVille: p?.residenceVille,
          residenceCodePostal: p?.residenceCodePostal,
          contactUrgencePrenom: p?.personneToContactUrgencePrenom,
          contactUrgenceNom: p?.personneToContactUrgenceNom,
          contactUrgenceTelIndicatif: p?.personneToContactUrgenceTelIndicatif?.id,
          contactUrgenceTel: p?.personneToContactUrgenceTel,
          statut: p?.statut,
          contrat: p?.contrat,
          poste: p?.personnelPostes?.[0]?.poste?.id,
          posteCategorie: p?.personnelPostes?.[0]?.poste?.categorie,
          agence: p?.agence?.id,
          entite: p?.mainEntite?.id,
          dateEntree: p?.dateEntree ? moment(p.dateEntree).format("YYYY-MM-DD") : undefined,
          linkedinUrl: p?.linkedinUrl,
          heuresTravail: p?.heuresTravail,
          heuresSupp: p?.heuresTravailSupp,
          // TYPE_DEFAULT est la ligne de base (toujours présente côté back) : on ne l'expose pas dans le select (TT / École uniquement).
          optionLignesCra: (p?.typesLigneActiviteCraAutorises ?? []).filter(t => t !== "TYPE_DEFAULT"),
     }
}

const FormCreate = () => {
     const navigate = useNavigate()
     const { currentUser } = useAuth()
     const { id } = useParams<{ id: string }>()
     const editDemandeId = id ? Number(id) : null

     // Responsable direct par défaut = utilisateur connecté (créateur), modifiable.
     const connectedPersonnelId = currentUser?.personnel?.id
     const connectedPersonnelOption = connectedPersonnelId ? [{ value: connectedPersonnelId, label: currentUser?.personnel?.prenomNom ?? "Moi" }] : []

     const [step, setStep] = React.useState<number>(0)
     // Aperçu de l'avatar (widget image-input metronic, comme le workflow consultant).
     const [avatarPreview, setAvatarPreview] = React.useState<string>(toAbsoluteUrl("/media/svg/avatars/blank.svg"))
     // Salarié vs non salarié : premier choix du formulaire, pilote l'enchaînement des étapes et les champs.
     const [estSalarie, setEstSalarie] = React.useState<boolean>(true)
     const steps = React.useMemo(() => buildSteps(estSalarie), [estSalarie])
     // Fournisseur (non salarié) : modales d'ajout + libellé du fournisseur sélectionné (pour la modale responsable).
     const [isAddingFournisseur, setIsAddingFournisseur] = React.useState<boolean>(false)
     const [isAddingFournisseurResp, setIsAddingFournisseurResp] = React.useState<boolean>(false)
     const [selectedFournisseurLabel, setSelectedFournisseurLabel] = React.useState<string>("")
     // Options par défaut pour afficher le fournisseur / contact déjà sélectionné (les selects async ne chargent qu'au focus).
     const [fournisseurDefaultOption, setFournisseurDefaultOption] = React.useState<{ label: string; value: number }[]>([])
     const [responsableDefaultOption, setResponsableDefaultOption] = React.useState<{ label: string; value: number }[]>([])
     // Étape la plus avancée atteinte (autorise la navigation avant vers les étapes déjà complétées).
     const [maxStepReached, setMaxStepReached] = React.useState<number>(0)
     // En mode édition, la demande existe déjà : l'étape 0 met à jour (setInfoPerso) au lieu de créer (start).
     const [demandeId, setDemandeId] = React.useState<number | null>(editDemandeId)
     const [saving, setSaving] = React.useState<boolean>(false)
     const [documents, setDocuments] = React.useState<IPersonnelDocumentModel[]>([])
     const [loading, setLoading] = React.useState<boolean>(!!editDemandeId)
     const [reloading, setReloading] = React.useState<boolean>(false)
     const [prefill, setPrefill] = React.useState<IPersonnelDEFormModel | null>(null)
     // État de la demande (édition) : sert à proposer l'envoi après correction d'une rectification.
     const [demandeEtat, setDemandeEtat] = React.useState<string | null>(null)
     const isRectif = demandeEtat === "ETAT_RECTIF_PAR_DG" || demandeEtat === "ETAT_RECTIF_PAR_HR"
     // « Sans diplôme » du collaborateur (rend le document Diplômes facultatif) — repris à la reprise d'une demande.
     const [sansDiplome, setSansDiplome] = React.useState<boolean>(false)
     // Préremplissage IA (étape 1) : type en cours d'analyse, documents téléversés avant création de la demande,
     // et nom de fichier téléversé par type (retour visuel « ✓ » sur la tuile).
     // Types de documents en cours d'analyse IA (chaque tuile est indépendante : analyser l'un ne bloque pas les autres).
     const [extractingTypes, setExtractingTypes] = React.useState<Set<string>>(new Set())
     const [pendingIdentityDocs, setPendingIdentityDocs] = React.useState<{ type: string; file: File }[]>([])
     const [identityDocNames, setIdentityDocNames] = React.useState<Record<string, string>>({})
     // Tuile survolée par un glisser-déposer (retour visuel « déposez ici »).
     const [dragOverType, setDragOverType] = React.useState<string | null>(null)
     // Survol glisser-déposer de la photo/avatar.
     const [avatarDragOver, setAvatarDragOver] = React.useState<boolean>(false)

     // Verrouille (non éditable + grisé) les champs concernés par le document en cours d'analyse IA.
     const lockStyleByType = (docType: string): React.CSSProperties | undefined =>
          extractingTypes.has(docType) ? { pointerEvents: "none", opacity: 0.55 } : undefined

     // Remonter en haut à chaque changement d'étape
     React.useEffect(() => {
          window.scrollTo({ top: 0, behavior: "smooth" })
     }, [step])

     React.useEffect(() => {
          if (!editDemandeId) return
          personnelDEGetDetailsRequest(editDemandeId)
               .then(r => {
                    setPrefill(buildPrefillFromDemande(r.data))
                    setDocuments((r.data.personnel?.personnelDocuments ?? []).filter(d => !d.isDeleted))
                    setSansDiplome(!!r.data.personnel?.sansDiplome)
                    setDemandeEtat(r.data.etat ?? null)
                    // Reprise de la photo déjà téléversée (Drive).
                    const avatarId = (r.data.personnel as any)?.avatarGoogleDriveId
                    if (avatarId) setAvatarPreview(driveImageUrl(avatarId))
                    // Reprise du fournisseur / contact déjà sélectionné (pour l'affichage des selects async).
                    const fx = (r.data.personnel as any)?.fournisseur
                    const frx = (r.data.personnel as any)?.fournisseurResponsable
                    if (fx?.id) {
                         setFournisseurDefaultOption([{ label: fx.raisonSociale ?? `Fournisseur #${fx.id}`, value: fx.id }])
                         setSelectedFournisseurLabel(fx.raisonSociale ?? "")
                    }
                    if (frx?.id) setResponsableDefaultOption([{ label: frx.prenomNom ?? `Contact #${frx.id}`, value: frx.id }])
                    // Type de collaborateur (salarié / non salarié) puis reprise à la dernière étape enregistrée.
                    const es = (r.data.personnel as any)?.statut !== STATUT_NON_SALARIE
                    setEstSalarie(es)
                    const stepsForEs = buildSteps(es)
                    const idx = stepsForEs.findIndex(s => s.key === (r.data.lastStep ?? STEP_KEY_INFO))
                    const lastStepIdx = idx >= 0 ? idx : 0
                    setStep(lastStepIdx)
                    setMaxStepReached(lastStepIdx)
               })
               .catch(() => toast.error("Impossible de charger la demande."))
               .finally(() => setLoading(false))
     }, [editDemandeId])

     // `.when("estSalarie", …)` : les champs d'identité complète, statut/contrat et Temps ne sont requis
     // que pour un salarié ; le fournisseur et le taux journalier ne le sont que pour un non salarié.
     const requiredIfSalarie = { is: true, then: (s: any) => s.required() }
     const requiredIfNonSalarie = { is: false, then: (s: any) => s.required() }
     const schema = Yup.object().shape({
          civilite: Yup.string().nullable().label(`"Civilité"`).required(),
          nom: Yup.string().nullable().label(`"Nom"`).required(),
          prenom: Yup.string().nullable().label(`"Prénom"`).required(),
          emailPro: Yup.string().nullable().email().label(`"Email pro."`).required(),
          telProIndicatif: Yup.number().nullable().label(`"Indicatif tél. pro."`).required(),
          telPro: Yup.string().nullable().label(`"Téléphone pro."`).required(),
          mailPersonnel: Yup.string().nullable().email().label(`"Email personnel"`).required(),
          telPersonnelIndicatif: Yup.number().nullable().label(`"Indicatif tél. perso."`).required(),
          telPersonnel: Yup.string().nullable().label(`"Téléphone personnel"`).required(),
          dateNaissance: Yup.string().nullable().label(`"Date de naissance"`).when("estSalarie", requiredIfSalarie),
          nSecuriteSociale: Yup.string().nullable().label(`"N° de sécurité sociale"`).when("estSalarie", requiredIfSalarie),
          paysNaissance: Yup.number().nullable().label(`"Pays de naissance"`).when("estSalarie", requiredIfSalarie),
          villeNaissance: Yup.string()
               .nullable()
               .label(`"Ville de naissance"`)
               .when(["estSalarie", "paysNaissance"], { is: (es: boolean, pn: number) => es && !!pn, then: s => s.required() }),
          nationalite: Yup.number()
               .nullable()
               .label(`"Nationalité"`)
               .when("isNationaliteEtrangere", { is: true, then: s => s.required() }),
          residenceAdresse: Yup.string().nullable().label(`"Adresse de résidence"`).when("estSalarie", requiredIfSalarie),
          residencePays: Yup.number().nullable().label(`"Pays de résidence"`).when("estSalarie", requiredIfSalarie),
          residenceCodePostal: Yup.string().nullable().label(`"Code postal"`).when("estSalarie", requiredIfSalarie),
          residenceVilleFrance: Yup.number()
               .nullable()
               .label(`"Ville de résidence"`)
               .when(["estSalarie", "residencePays"], { is: (es: boolean, rp: number) => es && rp === CONST_PAYS_ID_FRANCE, then: s => s.required() }),
          residenceVille: Yup.string()
               .nullable()
               .label(`"Ville de résidence"`)
               .when(["estSalarie", "residencePays"], { is: (es: boolean, rp: number) => es && !!rp && rp !== CONST_PAYS_ID_FRANCE, then: s => s.required() }),
          contactUrgencePrenom: Yup.string().label(`"Prénom (contact urgence)"`).nullable(),
          contactUrgenceNom: Yup.string().label(`"Nom (contact urgence)"`).nullable(),
          contactUrgenceTelIndicatif: Yup.number().label(`"Indicatif (contact urgence)"`).nullable(),
          contactUrgenceTel: Yup.string().label(`"Téléphone (contact urgence)"`).nullable(),
          // Fournisseur (non salarié)
          fournisseur: Yup.number().nullable().label(`"Fournisseur"`).when("estSalarie", requiredIfNonSalarie),
          fournisseurResponsable: Yup.number().nullable().label(`"Contact fournisseur"`).when("estSalarie", requiredIfNonSalarie),
          // Poste & organisation
          statut: Yup.string().nullable().label(`"Statut"`).when("estSalarie", requiredIfSalarie),
          contrat: Yup.string().nullable().label(`"Contrat"`).when("estSalarie", requiredIfSalarie),
          agence: Yup.number().nullable().label(`"Agence"`).required(),
          poste: Yup.number().nullable().label(`"Métier"`).required(),
          entite: Yup.number().nullable().label(`"Entité de rattachement"`).required(),
          entiteFacturation: Yup.number().nullable().label(`"Entité de facturation"`).required(),
          responsable: Yup.number().nullable().label(`"Responsable direct"`).required(),
          dateEntree: Yup.string().nullable().label(`"Date d'entrée"`).required(),
          salaireBrutMensuel: Yup.number().nullable().label(`"Salaire brut mensuel"`).when("estSalarie", requiredIfSalarie),
          tauxJournalierHt: Yup.number().nullable().label(`"Taux journalier HT"`).when("estSalarie", requiredIfNonSalarie),
          linkedinUrl: Yup.string()
               .nullable()
               .url("Le lien du profil LinkedIn doit être une URL valide (https://…).")
               .label(`"Lien du profil LinkedIn"`)
               .when("posteCategorie", { is: CATEGORIE_COMMERCIAL, then: s => s.required("Le lien du profil LinkedIn est requis pour un métier commercial.") }),
          heuresTravail: Yup.number().nullable().label(`"Heures travail"`).when("estSalarie", requiredIfSalarie),
          heuresSupp: Yup.number().nullable().label(`"Heures supp."`).when("estSalarie", requiredIfSalarie),
          optionLignesCra: Yup.array().label(`"Lignes CRA"`),
     })

     const initialValues: IPersonnelDEFormModel = prefill
          ? { ...prefill, responsable: prefill.responsable ?? connectedPersonnelId }
          : {
                 estSalarie: true,
                 civilite: CONST_CIVILITE_MR,
                 telProIndicatif: CONST_PAYS_ID_FRANCE,
                 telPersonnelIndicatif: CONST_PAYS_ID_FRANCE,
                 isNationaliteEtrangere: false,
                 responsable: connectedPersonnelId,
                 dateEntree: moment().format("YYYY-MM-DD"),
                 heuresTravail: 7,
                 heuresSupp: 0,
                 optionLignesCra: [],
            }

     function buildInfoPersoPayload(v: IPersonnelDEFormModel): IPersonnelDEInfoPersoRequestModel {
          return {
               estSalarie: v.estSalarie ?? true,
               avatar: v.avatar,
               civilite: v.civilite,
               nom: formatNom(v.nom),
               prenom: formatPrenom(v.prenom),
               emailPro: v.emailPro,
               telProIndicatif: v.telProIndicatif,
               telPro: v.telPro,
               mailPersonnel: v.mailPersonnel,
               telPersonnelIndicatif: v.telPersonnelIndicatif,
               telPersonnel: v.telPersonnel,
               dateNaissance: v.dateNaissance,
               nSecuriteSociale: v.nSecuriteSociale,
               paysNaissance: v.paysNaissance,
               villeNaissance: v.villeNaissance,
               isNationaliteEtrangere: v.isNationaliteEtrangere,
               nationalite: v.isNationaliteEtrangere ? v.nationalite : undefined,
               residenceAdresse: v.residenceAdresse,
               residencePays: v.residencePays,
               residenceVilleFrance: v.residencePays === CONST_PAYS_ID_FRANCE ? v.residenceVilleFrance : undefined,
               residenceVille: v.residencePays && v.residencePays !== CONST_PAYS_ID_FRANCE ? v.residenceVille : undefined,
               residenceCodePostal: v.residenceCodePostal,
               contactUrgencePrenom: v.contactUrgencePrenom,
               contactUrgenceNom: v.contactUrgenceNom,
               contactUrgenceTelIndicatif: v.contactUrgenceTelIndicatif,
               contactUrgenceTel: v.contactUrgenceTel,
          }
     }

     function buildPostePayload(v: IPersonnelDEFormModel): IPersonnelDEPosteRequestModel {
          const estSal = v.estSalarie ?? true
          return {
               // Statut/contrat : le non salarié est figé côté back (NON_SALARIE) → on n'envoie que pour un salarié.
               statut: estSal ? v.statut : undefined,
               contrat: estSal ? v.contrat : undefined,
               poste: v.poste,
               agence: v.agence,
               entite: v.entite,
               entiteFacturation: v.entiteFacturation,
               responsable: v.responsable,
               dateEntree: v.dateEntree,
               linkedinUrl: v.linkedinUrl,
               salaireBrutMensuel: estSal ? v.salaireBrutMensuel : undefined,
               tauxJournalierHt: estSal ? undefined : v.tauxJournalierHt,
          }
     }

     function buildFournisseurPayload(v: IPersonnelDEFormModel): IPersonnelDEFournisseurRequestModel {
          return {
               fournisseur: v.fournisseur,
               fournisseurResponsable: v.fournisseurResponsable,
               type: v.type,
               formeJuridique: v.formeJuridique,
               raisonSociale: v.raisonSociale,
               siret: v.siret,
               adresse: v.adresse,
               ville: v.ville,
               codePostal: v.codePostal,
               pays: v.pays,
          }
     }

     // Sélection d'un fournisseur : réinitialise le contact et pré-remplit les champs éditables du fournisseur.
     function handleChangeFournisseur(fournisseurId: number, helpers: FormikProps<IPersonnelDEFormModel>) {
          if (!fournisseurId) return
          helpers.setFieldValue("fournisseurResponsable", undefined)
          getFournisseurSimpleDetails(fournisseurId)
               .then(r => {
                    const f = r.data as any
                    helpers.setFieldValue("type", f?.type)
                    helpers.setFieldValue("formeJuridique", f?.formeJuridique)
                    helpers.setFieldValue("raisonSociale", f?.raisonSociale)
                    helpers.setFieldValue("siret", f?.siret)
                    helpers.setFieldValue("adresse", f?.adresse)
                    helpers.setFieldValue("ville", f?.ville)
                    helpers.setFieldValue("codePostal", f?.codePostal)
                    helpers.setFieldValue("pays", f?.pays?.id)
               })
               .catch(() => toast.error("Impossible de récupérer les informations du fournisseur.", { autoClose: false }))
     }

     function buildTempsPayload(v: IPersonnelDEFormModel): IPersonnelDETempsRequestModel {
          return { heuresTravail: v.heuresTravail, heuresSupp: v.heuresSupp, optionLignesCra: v.optionLignesCra }
     }

     function handleServerError(e: AxiosError, helpers: FormikProps<IPersonnelDEFormModel>) {
          const error: IHttpErrorResponseModel = e.response?.data as IHttpErrorResponseModel
          if (error?.code === CONST_HTTP_CUSTOM_CODE_FORM_VALIDATION_ERROR && error?.errors) {
               for (const key in error.errors) helpers.setFieldError(key, error.errors[key])
          }
          toast.error(error?.detail ?? "Une erreur est survenue.", { autoClose: false })
     }

     // Applique les champs extraits par l'IA — UNIQUEMENT sur les champs vides (jamais d'écrasement d'une saisie).
     // Les selects (nationalité/pays/ville France) ne reçoivent que l'id : les composants réhydratent le libellé.
     function applyExtractedIdentityFields(fields: IPersonnelIdentityExtractionModel["fields"], helpers: FormikProps<IPersonnelDEFormModel>) {
          const isEmpty = (v: any) => v === undefined || v === null || v === ""
          const fillIfEmpty = (name: keyof IPersonnelDEFormModel, value: any) => {
               if (isEmpty(value)) return
               if (!isEmpty((helpers.values as any)[name])) return
               helpers.setFieldValue(name as string, value)
          }
          // N° sécu : on pose la valeur formatée au masque (les chiffres bruts ne seraient pas reformatés par useMask).
          fillIfEmpty("nSecuriteSociale", fields.nSecuriteSociale ? formatWithMask(fields.nSecuriteSociale, MASK_SECU) : undefined)
          // Civilité : le champ a une valeur par défaut (Monsieur) → « fill-empty » ne s'applique pas. On remplace
          // tant que l'utilisateur n'a pas choisi une autre civilité que le défaut.
          if (fields.civilite && (isEmpty(helpers.values.civilite) || helpers.values.civilite === CONST_CIVILITE_MR)) {
               helpers.setFieldValue("civilite", fields.civilite)
          }
          fillIfEmpty("nom", fields.nom ? formatNom(fields.nom) : undefined)
          fillIfEmpty("prenom", fields.prenom ? formatPrenom(fields.prenom) : undefined)
          fillIfEmpty("dateNaissance", fields.dateNaissance)
          fillIfEmpty("paysNaissance", fields.paysNaissance?.id)
          fillIfEmpty("mailPersonnel", fields.mailPersonnel)
          fillIfEmpty("residenceAdresse", fields.residenceAdresse)
          fillIfEmpty("residenceCodePostal", fields.residenceCodePostal)
          fillIfEmpty("residenceVille", fields.residenceVille)
          fillIfEmpty("residencePays", fields.residencePays?.id)
          fillIfEmpty("residenceVilleFrance", fields.residenceVilleFrance?.id)
          fillIfEmpty("telPersonnel", fields.telPersonnel)
          // Indicatif tél. perso : le back ne renvoie l'indicatif que s'il est étranger et résolu → on l'applique
          // (remplace le défaut +33 France). Sinon (absent / +33) on conserve le défaut.
          if (fields.telPersonnelIndicatif?.id) helpers.setFieldValue("telPersonnelIndicatif", fields.telPersonnelIndicatif.id)
          // Nationalité étrangère : ne renseigner que si aucune nationalité n'est déjà saisie.
          if (fields.nationalite?.id && isEmpty(helpers.values.nationalite)) {
               helpers.setFieldValue("isNationaliteEtrangere", true)
               helpers.setFieldValue("nationalite", fields.nationalite.id)
          }
          // Email pro : reconstruit s'il est vide et qu'on dispose désormais du prénom + nom.
          const finalPrenom = helpers.values.prenom || (fields.prenom ? formatPrenom(fields.prenom) : "")
          const finalNom = helpers.values.nom || (fields.nom ? formatNom(fields.nom) : "")
          if (isEmpty(helpers.values.emailPro) && finalPrenom && finalNom) {
               helpers.setFieldValue("emailPro", `${toEmailPart(finalPrenom)}.${toEmailPart(finalNom)}@cts-corporate.com`)
          }
     }

     // Applique une photo (clic ou glisser-déposer) : validation image + aperçu + champ Formik.
     function applyAvatarFile(file: File | undefined, helpers: FormikProps<IPersonnelDEFormModel>) {
          if (!file) return
          if (!file.type.startsWith("image/")) {
               toast.error("Veuillez fournir une image (PNG ou JPG).")
               return
          }
          helpers.setFieldValue("avatar", file)
          const reader = new FileReader()
          reader.onloadend = () => setAvatarPreview(reader.result as string)
          reader.readAsDataURL(file)
     }

     // Upload d'un document d'identité en étape 1 : extraction IA (préremplissage des champs vides) + rattachement
     // à l'onglet Documents (immédiat si la demande existe, sinon différé à l'enregistrement de l'étape). Non bloquant.
     async function handleIdentityDocUpload(type: string, file: File | undefined, helpers: FormikProps<IPersonnelDEFormModel>) {
          if (!file) return
          setExtractingTypes(prev => new Set(prev).add(type))
          try {
               const r = await personnelExtractIdentityDocumentRequest(type, file)
               applyExtractedIdentityFields(r.data?.fields ?? {}, helpers)
               if (demandeId) {
                    try {
                         const rr = await personnelDEAddDocumentRequest(demandeId, type, file)
                         setDocuments(prev => [...prev, rr.data as IPersonnelDocumentModel])
                    } catch { /* rattachement non bloquant */ }
               } else {
                    setPendingIdentityDocs(prev => [...prev.filter(d => d.type !== type), { type, file }])
               }
               setIdentityDocNames(prev => ({ ...prev, [type]: file.name }))
               toast.success("Document analysé — les champs vides ont été préremplis. Vérifiez avant de continuer.")
          } catch (e) {
               const err = (e as AxiosError)?.response?.data as IHttpErrorResponseModel
               toast.error(err?.detail ?? "Analyse du document impossible. Vous pouvez saisir les informations manuellement.", { autoClose: false })
          } finally {
               setExtractingTypes(prev => { const next = new Set(prev); next.delete(type); return next })
          }
     }

     // Sauvegarde l'étape courante côté serveur, puis avance
     async function saveStepAndNext(helpers: FormikProps<IPersonnelDEFormModel>) {
          const currentStep = steps[step]
          const stepFields = currentStep.fields
          const errors = await helpers.validateForm()
          const stepErrors = stepFields.filter(f => (errors as any)[f])
          if (stepErrors.length > 0) {
               stepFields.forEach(f => helpers.setFieldTouched(f as string, true))
               const messages = stepErrors.map(f => (errors as any)[f]).filter(Boolean)
               toast.error(`Champs à corriger : ${messages.join(" · ")}`, { autoClose: false })
               return
          }

          setSaving(true)
          try {
               if (currentStep.key === STEP_KEY_INFO) {
                    const payload = buildInfoPersoPayload(helpers.values)
                    let currentDemandeId = demandeId
                    if (!demandeId) {
                         const r = await personnelDEStartRequest(payload)
                         currentDemandeId = r.data.id
                         setDemandeId(r.data.id)
                         // Sans cela, demandeEtat reste null et le slot « Contrat de travail » (créateur RH) ne s'affiche pas.
                         setDemandeEtat(r.data.etat ?? null)
                         setDocuments((r.data.personnel?.personnelDocuments ?? []).filter(d => !d.isDeleted))
                         // Refléter l'id de la demande dans l'URL (→ /editer/{id}) sans remonter le composant : le
                         // wizard poursuit à l'étape suivante, et un rafraîchissement recharge la demande au lieu
                         // d'afficher un formulaire vide.
                         window.history.replaceState(null, "", ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_DEMANDE_EMBAUCHE_EDITER(r.data.id))
                    } else {
                         await personnelDESetInfoPersoRequest(demandeId, payload)
                    }
                    // Non salarié : le fournisseur (+ responsable + détails) est saisi dans cette même étape.
                    if (!estSalarie && currentDemandeId) {
                         await personnelDESetFournisseurRequest(currentDemandeId, buildFournisseurPayload(helpers.values))
                    }
                    // Documents d'identité téléversés en étape 1 avant la création de la demande : on les rattache
                    // maintenant à l'onglet Documents (« synchronisation »). Non bloquant.
                    if (currentDemandeId && pendingIdentityDocs.length > 0) {
                         const uploaded: IPersonnelDocumentModel[] = []
                         for (const d of pendingIdentityDocs) {
                              try {
                                   const rr = await personnelDEAddDocumentRequest(currentDemandeId, d.type, d.file)
                                   uploaded.push(rr.data as IPersonnelDocumentModel)
                              } catch { /* rattachement non bloquant */ }
                         }
                         if (uploaded.length > 0) setDocuments(prev => [...prev, ...uploaded])
                         setPendingIdentityDocs([])
                    }
               } else if (currentStep.key === STEP_KEY_POSTE) {
                    await personnelDESetPosteRequest(demandeId as number, buildPostePayload(helpers.values))
               } else if (currentStep.key === STEP_KEY_TEMPS) {
                    await personnelDESetTempsRequest(demandeId as number, buildTempsPayload(helpers.values))
               }

               // Demande en rectification : proposer l'envoi après correction.
               if (isRectif && demandeId) {
                    const res = await Swal.fire({
                         icon: "question",
                         title: "Avez-vous terminé la correction ?",
                         text: "Souhaitez-vous envoyer la demande d'embauche corrigée ?",
                         input: "textarea",
                         inputLabel: "Commentaire (facultatif)",
                         inputPlaceholder: "Précisez les corrections apportées…",
                         showCancelButton: true,
                         confirmButtonText: "Oui, envoyer",
                         cancelButtonText: "Non, continuer",
                    })
                    if (res.isConfirmed) {
                         await personnelDESoumettreRequest(demandeId, (res.value ?? "").trim() || undefined)
                         toast.success("La demande d'embauche a bien été envoyée")
                         navigate(ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE)
                         return
                    }
               }

               const next = Math.min(step + 1, steps.length - 1)
               setStep(next)
               setMaxStepReached(m => Math.max(m, next))
          } catch (e) {
               handleServerError(e as AxiosError, helpers)
          } finally {
               setSaving(false)
          }
     }

     async function finish() {
          // Demande en rectification : proposer d'envoyer la correction depuis la dernière étape.
          if (isRectif && demandeId) {
               const res = await Swal.fire({
                    icon: "question",
                    title: "Avez-vous terminé la correction ?",
                    text: "Souhaitez-vous envoyer la demande d'embauche corrigée ?",
                    input: "textarea",
                    inputLabel: "Commentaire (facultatif)",
                    inputPlaceholder: "Précisez les corrections apportées…",
                    showCancelButton: true,
                    confirmButtonText: "Oui, envoyer",
                    cancelButtonText: "Non",
               })
               if (!res.isConfirmed) return
               setSaving(true)
               try {
                    await personnelDESoumettreRequest(demandeId, (res.value ?? "").trim() || undefined)
                    toast.success("La demande d'embauche a bien été envoyée")
                    navigate(ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE)
               } catch (e) {
                    const err = (e as AxiosError)?.response?.data as IHttpErrorResponseModel
                    toast.error(err?.detail ?? "Une erreur est survenue.", { autoClose: false })
               } finally {
                    setSaving(false)
               }
               return
          }
          // Brouillon terminé : proposer de soumettre directement à la DG (sans repasser par la liste).
          if (demandeId) {
               const res = await Swal.fire({
                    icon: "question",
                    title: "Demande enregistrée",
                    text: "Souhaitez-vous soumettre la demande maintenant ? Vous pourrez aussi le faire plus tard depuis la liste des demandes.",
                    input: "textarea",
                    inputLabel: "Commentaire (facultatif)",
                    inputPlaceholder: "Ajouter un commentaire…",
                    showCancelButton: true,
                    confirmButtonText: "Oui, soumettre",
                    cancelButtonText: "Plus tard",
               })
               if (res.isConfirmed) {
                    setSaving(true)
                    try {
                         await personnelDESoumettreRequest(demandeId, (res.value ?? "").trim() || undefined)
                         toast.success("La demande d'embauche a bien été soumise")
                         navigate(ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE)
                    } catch (e) {
                         const err = (e as AxiosError)?.response?.data as IHttpErrorResponseModel
                         toast.error(err?.detail ?? "Une erreur est survenue.", { autoClose: false })
                    } finally {
                         setSaving(false)
                    }
                    return
               }
          }
          toast.success("La demande d'embauche a été enregistrée. Vous pouvez la soumettre depuis la liste des demandes.")
          navigate(ROUTING_ABSOLUTE_PATH_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE)
     }

     // Recharge la demande depuis le backend (source de vérité) puis positionne l'étape.
     async function goToStep(helpers: FormikProps<IPersonnelDEFormModel>, target: number) {
          if (demandeId) {
               setReloading(true)
               try {
                    const r = await personnelDEGetDetailsRequest(demandeId)
                    const values = buildPrefillFromDemande(r.data)
                    helpers.setValues({ ...values, responsable: values.responsable ?? connectedPersonnelId })
                    setDocuments((r.data.personnel?.personnelDocuments ?? []).filter(d => !d.isDeleted))
               } catch {
                    toast.error("Impossible de recharger la demande.")
               } finally {
                    setReloading(false)
               }
          }
          setStep(Math.max(Math.min(target, steps.length - 1), 0))
     }

     function goPrevious(helpers: FormikProps<IPersonnelDEFormModel>) {
          return goToStep(helpers, step - 1)
     }

     if (loading) return <CenteredLoader />

     return (
          <Formik initialValues={initialValues} onSubmit={() => {}} validationSchema={schema}>
               {helpers => {
                    const title = editDemandeId ? `${helpers.values.prenom ?? ""} ${helpers.values.nom ?? ""}`.trim() || "Demande d'embauche" : "Ajouter un collaborateur"
                    const currentKey = steps[step]?.key ?? STEP_KEY_INFO
                    return (
                    <>
                    <PageTitle breadcrumbs={ROUTING_BREADCRUMBS_GESTION_STRUCTURE_STAFF_DEMANDES_EMBAUCHE}>{title}</PageTitle>
                    <div className="d-flex justify-content-center">
                         <div className="w-100 w-lg-80 w-xl-60 w-xxl-55">
                              <MyCard>
                                   <MyCard.Header>{title}</MyCard.Header>
                                   <MyCard.Body>
                    <Form noValidate autoComplete="off">
                         {/* Alternance → présélection « École » dans les options CRA */}
                         <AlternanceCraDefaultEffect contrat={helpers.values.contrat} optionLignesCra={helpers.values.optionLignesCra} setFieldValue={helpers.setFieldValue} />
                         {/* Stepper : barres de progression segmentées + pastilles numérotées */}
                         <div className="d-flex align-items-start gap-2 gap-md-4 mb-8">
                              {steps.map((s, idx) => {
                                   const reached = idx <= maxStepReached
                                   const current = idx === step
                                   const clickable = reached && !current
                                   return (
                                        <div
                                             key={s.title}
                                             className="flex-fill"
                                             style={{ minWidth: 0, cursor: clickable ? "pointer" : "default" }}
                                             onClick={() => clickable && goToStep(helpers, idx)}
                                             title={s.title}
                                        >
                                             <div
                                                  className={`rounded-pill mb-3 ${current ? "bg-primary" : reached ? "bg-light-primary" : "bg-gray-200"}`}
                                                  style={{ height: 5 }}
                                             />
                                             <div className="d-flex align-items-center">
                                                  <span
                                                       className={`d-flex align-items-center justify-content-center rounded-circle fw-bold flex-shrink-0 ${
                                                            current ? "bg-primary text-white" : reached ? "bg-light-primary text-primary" : "bg-light text-muted"
                                                       }`}
                                                       style={{ width: 30, height: 30, fontSize: 12 }}
                                                  >
                                                       {reached && !current ? <i className="fas fa-check fs-8" /> : idx + 1}
                                                  </span>
                                                  <div className="ms-2 d-none d-md-block text-truncate">
                                                       <div className={`fw-bold fs-8 text-truncate ${current ? "text-gray-900" : reached ? "text-primary" : "text-muted"}`}>{s.title}</div>
                                                  </div>
                                             </div>
                                        </div>
                                   )
                              })}
                         </div>

                         {/* Contenu toujours monté (évite le re-fetch des selects async au rechargement) ; loader en overlay */}
                         <div className="position-relative">
                         {reloading && (
                              <div
                                   className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center rounded"
                                   style={{ zIndex: 10, background: "rgba(255, 255, 255, 0.75)" }}
                              >
                                   <MySimpleSpinner size={"xl"} />
                              </div>
                         )}
                         {/* ================= STEP 0 — Identité & contact ================= */}
                         <div style={{ display: currentKey === STEP_KEY_INFO ? "block" : "none" }}>
                              {/* Premier choix : salarié ou non salarié — pilote la suite du formulaire. */}
                              <div className="mb-8">
                                   <label className="form-label fw-bold">Type de collaborateur</label>
                                   <div className="btn-group w-100" role="group">
                                        <button
                                             type="button"
                                             className={`btn ${estSalarie ? "btn-primary" : "btn-light"}`}
                                             onClick={() => {
                                                  setEstSalarie(true)
                                                  helpers.setFieldValue("estSalarie", true)
                                             }}
                                        >
                                             <i className="fas fa-user-tie me-2" /> Salarié
                                        </button>
                                        <button
                                             type="button"
                                             className={`btn ${!estSalarie ? "btn-primary" : "btn-light"}`}
                                             onClick={() => {
                                                  setEstSalarie(false)
                                                  helpers.setFieldValue("estSalarie", false)
                                             }}
                                        >
                                             <i className="fas fa-building me-2" /> Non salarié
                                        </button>
                                   </div>
                                   <div className="text-muted fs-8 mt-2">
                                        {estSalarie ? "Collaborateur salarié (CDI / CDD / stage)." : "Collaborateur non salarié : un fournisseur (portage / service / freelance) sera rattaché."}
                                   </div>
                              </div>

                              {/* ================= Préremplissage IA (salarié) — placé en tête pour être vu AVANT la saisie.
                                  Masqué une fois l'étape 1 complétée (la demande existe) : les documents sont alors dans l'onglet « Documents ». ================= */}
                              {estSalarie && !demandeId && (
                                   <div className="card border border-primary border-dashed bg-light-primary mb-10">
                                        <div className="card-body p-6">
                                             <div className="d-flex align-items-center mb-4">
                                                  <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-primary flex-shrink-0 me-3" style={{ width: 40, height: 40 }}>
                                                       <i className="fas fa-wand-magic-sparkles text-white fs-4" />
                                                  </span>
                                                  <div>
                                                       <div className="fw-bold text-gray-900 fs-5">Gagnez du temps : préremplissage automatique (facultatif)</div>
                                                       <div className="text-muted fs-7">
                                                            Téléversez un document et les champs <strong>vides</strong> se remplissent tout seuls. Tout reste modifiable, et les fichiers sont ajoutés à l'onglet « Documents ».
                                                       </div>
                                                  </div>
                                             </div>
                                             <div className="row g-4">
                                                  {IDENTITY_EXTRACTION_SLOTS.map(slot => {
                                                       const done = !!identityDocNames[slot.type]
                                                       const busy = extractingTypes.has(slot.type)
                                                       const dragging = dragOverType === slot.type
                                                       const disabled = busy
                                                       return (
                                                            <div className="col-12 col-sm-6 col-lg-4" key={slot.type}>
                                                                 <div
                                                                      className={`h-100 d-flex flex-column rounded p-4 bg-body border ${dragging ? "border-primary border-2 bg-light-primary" : done ? "border-success" : "border-gray-300"}`}
                                                                      onDragOver={e => { e.preventDefault(); if (!disabled) setDragOverType(slot.type) }}
                                                                      onDragEnter={e => { e.preventDefault(); if (!disabled) setDragOverType(slot.type) }}
                                                                      onDragLeave={e => { e.preventDefault(); setDragOverType(prev => (prev === slot.type ? null : prev)) }}
                                                                      onDrop={e => {
                                                                           e.preventDefault()
                                                                           setDragOverType(null)
                                                                           if (disabled) return
                                                                           const f = e.dataTransfer.files?.[0]
                                                                           if (f) handleIdentityDocUpload(slot.type, f, helpers)
                                                                      }}
                                                                 >
                                                                      <div className="d-flex align-items-center mb-2">
                                                                           <i className={`${slot.icon} fs-3 text-primary me-3`} />
                                                                           <span className="fw-semibold text-gray-800">{slot.label}</span>
                                                                      </div>
                                                                      <div className="text-muted fs-8 mb-4 flex-grow-1">{slot.hint}</div>
                                                                      <label className={`btn btn-sm w-100 mb-0 ${done ? "btn-light-success" : "btn-light-primary"} ${disabled ? "disabled" : ""}`}>
                                                                           {busy ? (
                                                                                <span className="d-inline-flex align-items-center justify-content-center"><MySimpleSpinner size={"sm"} /><span className="ms-2">Analyse…</span></span>
                                                                           ) : done ? (
                                                                                <span className="d-inline-block text-truncate mw-100" title={identityDocNames[slot.type]}><i className="fas fa-circle-check me-2" />{identityDocNames[slot.type]}</span>
                                                                           ) : (
                                                                                <span><i className="fas fa-arrow-up-from-bracket me-2" />Téléverser</span>
                                                                           )}
                                                                           <input
                                                                                type="file"
                                                                                className="d-none"
                                                                                accept="application/pdf,image/*"
                                                                                disabled={disabled}
                                                                                onChange={e => {
                                                                                     const f = e.target.files?.[0]
                                                                                     handleIdentityDocUpload(slot.type, f, helpers)
                                                                                     e.target.value = ""
                                                                                }}
                                                                           />
                                                                      </label>
                                                                      <div className="text-muted fs-9 text-center mt-2">{dragging ? "Déposez le fichier ici" : "ou glissez-déposez le fichier"}</div>
                                                                 </div>
                                                            </div>
                                                       )
                                                  })}
                                             </div>
                                        </div>
                                   </div>
                              )}

                              {/* ================= Non salarié : Fournisseur + détails, puis collaborateur ================= */}
                              {!estSalarie && (
                                   <>
                                        <h3 className="fs-4 fw-bold text-gray-900 mb-4">Fournisseur</h3>
                                        <MySelectGetAllDataFromServerFormField
                                             name={"fournisseur"}
                                             label={requiredLabel("Choisissez le fournisseur")}
                                             formikProps={helpers}
                                             validationSchema={schema}
                                             method={"GET"}
                                             endpoint={CONST_API_UTILS_GET_FOURNISSEURS_ENDPOINT}
                                             defaultOptions={fournisseurDefaultOption}
                                             classNameLayout={"mb-1"}
                                             placeholder={"Rechercher un fournisseur"}
                                             onChangeCallback={(val: any, opt: any) => {
                                                  setSelectedFournisseurLabel(opt?.label ?? "")
                                                  setFournisseurDefaultOption(val ? [{ label: opt?.label ?? "", value: val as number }] : [])
                                                  setResponsableDefaultOption([])
                                                  handleChangeFournisseur(val as number, helpers)
                                             }}
                                        />
                                        <div className="text-end mb-6">
                                             <span className="text-primary fw-bold cursor-pointer" onClick={() => setIsAddingFournisseur(true)}>
                                                  Ajouter <i className="fas fa-plus-circle ms-1" />
                                             </span>
                                        </div>

                                        {helpers.values.fournisseur && (
                                             <>
                                                  <MySelectGetAllDataFromServerFormField
                                                       name={"fournisseurResponsable"}
                                                       label={requiredLabel("Contact fournisseur")}
                                                       formikProps={helpers}
                                                       validationSchema={schema}
                                                       method={"GET"}
                                                       endpoint={CONST_API_UTILS_GET_FOURNISSEURS_RESP_ENDPOINT}
                                                       payload={{ fournisseur: helpers.values.fournisseur }}
                                                       defaultOptions={responsableDefaultOption}
                                                       classNameLayout={"mb-1"}
                                                       placeholder={"Contact du fournisseur"}
                                                       onChangeCallback={(val: any, opt: any) => setResponsableDefaultOption(val ? [{ label: opt?.label ?? "", value: val as number }] : [])}
                                                  />
                                                  <div className="text-end mb-6">
                                                       <span className="text-primary fw-bold cursor-pointer" onClick={() => setIsAddingFournisseurResp(true)}>
                                                            Ajouter <i className="fas fa-plus-circle ms-1" />
                                                       </span>
                                                  </div>

                                                  <div className="separator separator-dashed mb-6" />
                                                  <h4 className="fs-6 fw-bold text-gray-700 mb-4">Détails du fournisseur</h4>
                                                  <div className="mb-6">
                                                       <label className="form-label">Catégorie</label>
                                                       <input
                                                            className="form-control form-control-solid"
                                                            value={CONST_FOURNISSEUR_TYPES_OPTIONS_FOR_SELECT2.find((o: any) => o.value === helpers.values.type)?.label ?? helpers.values.type ?? ""}
                                                            disabled
                                                            readOnly
                                                       />
                                                  </div>
                                                  <MySelectFormField name={"formeJuridique"} label={requiredLabel("Forme juridique")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Forme juridique"} options={CONST_FOURNISSEUR_FORMES_JURIDIQUE_OPTIONS_FOR_SELECT2} />
                                                  <MyInputFormField name={"raisonSociale"} label={requiredLabel("Raison sociale")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Raison sociale"} />
                                                  <MyInputFormField name={"siret"} label={requiredLabel("SIRET")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"SIRET"} />
                                                  <MyInputFormField name={"adresse"} label={requiredLabel("Adresse")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Adresse"} />
                                                  <div className="row mb-6">
                                                       <div className="col-md-6">
                                                            <MyInputFormField name={"ville"} label={requiredLabel("Ville")} formikProps={helpers} validationSchema={schema} placeholder={"Ville"} />
                                                       </div>
                                                       <div className="col-md-6">
                                                            <MyInputFormField name={"codePostal"} label={requiredLabel("Code postal")} formikProps={helpers} validationSchema={schema} placeholder={"Code postal"} inputMode={"numeric"} />
                                                       </div>
                                                  </div>
                                                  <MySelectGetAllDataFromServerFormField name={"pays"} label={requiredLabel("Pays")} formikProps={helpers} validationSchema={schema} method={"GET"} endpoint={CONST_API_UTILS_GET_PAYS_ENDPOINT} classNameLayout={"mb-6"} placeholder={"Pays"} />
                                             </>
                                        )}

                                        <div className="separator separator-dashed mb-6" />
                                        <h3 className="fs-4 fw-bold text-gray-900 mb-4">Collaborateur</h3>
                                   </>
                              )}

                              {/* Photo / avatar (facultatif, pour tous) — widget image-input metronic. */}
                              <div className="mb-8 text-center">
                                   <label className="form-label fw-bold d-block mb-3">Photo</label>
                                   <div
                                        className={`image-input image-input-outline ${avatarDragOver ? "border border-primary border-2 rounded" : ""}`}
                                        data-kt-image-input="true"
                                        style={{ backgroundImage: `url(${avatarPreview})` }}
                                        onDragOver={e => { e.preventDefault(); setAvatarDragOver(true) }}
                                        onDragEnter={e => { e.preventDefault(); setAvatarDragOver(true) }}
                                        onDragLeave={e => { e.preventDefault(); setAvatarDragOver(false) }}
                                        onDrop={e => { e.preventDefault(); setAvatarDragOver(false); applyAvatarFile(e.dataTransfer.files?.[0], helpers) }}
                                   >
                                        <img
                                             className="image-input-wrapper w-125px h-125px"
                                             src={avatarPreview}
                                             alt={""}
                                             referrerPolicy="no-referrer"
                                             onError={e => {
                                                  // Sur localhost, les vignettes Google Drive sont souvent bloquées : repli sur le placeholder.
                                                  const blank = toAbsoluteUrl("/media/svg/avatars/blank.svg")
                                                  if (e.currentTarget.src !== blank) e.currentTarget.src = blank
                                             }}
                                        />
                                        <label
                                             className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                             data-kt-image-input-action="change"
                                             data-bs-original-title="Changer la photo"
                                        >
                                             <i className="bi bi-pencil-fill fs-7" />
                                             <input
                                                  type="file"
                                                  name="avatar"
                                                  accept=".png, .jpg, .jpeg"
                                                  onChange={e => {
                                                       applyAvatarFile(e.target.files?.[0], helpers)
                                                       e.target.value = ""
                                                  }}
                                             />
                                        </label>
                                        {helpers.values.avatar && (
                                             <span
                                                  className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow"
                                                  data-kt-image-input-action="remove"
                                                  data-bs-original-title="Retirer la photo"
                                                  onClick={() => {
                                                       helpers.setFieldValue("avatar", undefined)
                                                       setAvatarPreview(toAbsoluteUrl("/media/svg/avatars/blank.svg"))
                                                  }}
                                             >
                                                  <i className="bi bi-x fs-2" />
                                             </span>
                                        )}
                                   </div>
                                   <div className="text-muted fs-8 mt-2">{avatarDragOver ? "Déposez la photo ici" : "Cliquez sur le crayon ou glissez-déposez une photo"}</div>
                              </div>

                              <div style={lockStyleByType(CONST_PERSONNEL_DOCUMENT_TYPE_PASSEPORT_CNI)}>
                              <MySelectFormField
                                   name={"civilite"}
                                   label={"Civilité"}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   classNameLayout={"mb-6"}
                                   placeholder={"Civilité"}
                                   options={CONST_CIVILITES_OPTIONS_FOR_SELECT2.filter(c => c.value !== CONST_CIVILITE_NON_RENSEIGNEE)}
                              />
                              <MyInputFormField
                                   name={"prenom"}
                                   label={"Prénom"}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   classNameLayout={"mb-6"}
                                   placeholder={"Prénom"}
                                   onChangeCallback={val => helpers.setFieldValue("emailPro", `${toEmailPart(val)}.${toEmailPart(helpers.values.nom)}@cts-corporate.com`)}
                              />
                              <MyInputFormField
                                   name={"nom"}
                                   label={"Nom"}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   classNameLayout={"mb-6"}
                                   placeholder={"Nom"}
                                   onChangeCallback={val => helpers.setFieldValue("emailPro", `${toEmailPart(helpers.values.prenom)}.${toEmailPart(val)}@cts-corporate.com`)}
                              />
                              </div>
                              <MyInputFormField
                                   name={"emailPro"}
                                   label={"Email pro."}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   classNameLayout={"mb-6"}
                                   placeholder={"Email pro."}
                                   onChangeCallback={val => helpers.setFieldValue("emailPro", stripAccents(val))}
                              />

                              <div className="row mb-6">
                                   <div className="col-md-6">
                                        <MySelectGetAllDataFromServerFormField
                                             name={"telProIndicatif"}
                                             label={"Indicatif tél. pro."}
                                             formikProps={helpers}
                                             validationSchema={schema}
                                             method={"GET"}
                                             endpoint={CONST_API_UTILS_GET_INDICATIF_TEL_ENDPOINT}
                                             placeholder={"Indicatif"}
                                             defaultOptions={[{ label: "+33 - France", value: CONST_PAYS_ID_FRANCE }]}
                                        />
                                   </div>
                                   <div className="col-md-6">
                                        <MyInputFormField name={"telPro"} label={"Téléphone pro."} formikProps={helpers} validationSchema={schema} placeholder={"Téléphone"} inputMode={"numeric"} />
                                   </div>
                              </div>

                              <div className="row mb-6" style={lockStyleByType(CONST_PERSONNEL_DOCUMENT_TYPE_CV)}>
                                   <div className="col-md-6">
                                        <MySelectGetAllDataFromServerFormField
                                             name={"telPersonnelIndicatif"}
                                             label={"Indicatif tél. perso."}
                                             formikProps={helpers}
                                             validationSchema={schema}
                                             method={"GET"}
                                             endpoint={CONST_API_UTILS_GET_INDICATIF_TEL_ENDPOINT}
                                             placeholder={"Indicatif"}
                                             defaultOptions={[{ label: "+33 - France", value: CONST_PAYS_ID_FRANCE }]}
                                        />
                                   </div>
                                   <div className="col-md-6">
                                        <MyInputFormField name={"telPersonnel"} label={"Téléphone personnel"} formikProps={helpers} validationSchema={schema} placeholder={"Téléphone"} inputMode={"numeric"} />
                                   </div>
                              </div>

                              <div style={lockStyleByType(CONST_PERSONNEL_DOCUMENT_TYPE_CV)}>
                              <MyInputFormField
                                   name={"mailPersonnel"}
                                   label={"Email personnel"}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   classNameLayout={"mb-6"}
                                   placeholder={"Email personnel"}
                                   onChangeCallback={val => helpers.setFieldValue("mailPersonnel", stripAccents(val))}
                              />
                              </div>

                              {/* Identité complète (naissance, sécu, résidence, contact urgence) : salarié uniquement. */}
                              {estSalarie && (
                              <>
                              <div className="separator separator-dashed mb-6" />

                              <div style={lockStyleByType(CONST_PERSONNEL_DOCUMENT_TYPE_ATTESTATION_SS)}>
                              <MyInputMaskFormField
                                   name={"nSecuriteSociale"}
                                   label={requiredLabel("N° de sécurité sociale")}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   classNameLayout={"mb-6"}
                                   placeholder={"N° de sécurité sociale"}
                                   mask={MASK_SECU}
                                   maskRegex={MASK_DIGIT}
                                   inputMode={"numeric"}
                              />
                              </div>
                              <div style={lockStyleByType(CONST_PERSONNEL_DOCUMENT_TYPE_PASSEPORT_CNI)}>
                              <MyDateDayMonthYearFormField name={"dateNaissance"} label={requiredLabel("Date de naissance")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Date de naissance"} isDisabled={extractingTypes.has(CONST_PERSONNEL_DOCUMENT_TYPE_PASSEPORT_CNI)} />

                              <MySelectGetAllDataFromServerFormField
                                   name={"paysNaissance"}
                                   label={requiredLabel("Pays de naissance")}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   method={"GET"}
                                   endpoint={CONST_API_UTILS_GET_PAYS_ENDPOINT}
                                   classNameLayout={"mb-6"}
                                   placeholder={"Pays de naissance"}
                              />
                              {helpers.values.paysNaissance && (
                                   <MyInputFormField name={"villeNaissance"} label={requiredLabel("Ville de naissance")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Ville de naissance"} />
                              )}
                              </div>

                              <div style={lockStyleByType(CONST_PERSONNEL_DOCUMENT_TYPE_PASSEPORT_CNI)}>
                              <MyCheckboxFormField
                                   name={"isNationaliteEtrangere"}
                                   label={"Nationalité étrangère ?"}
                                   text={"Le collaborateur est de nationalité étrangère"}
                                   formikProps={helpers}
                                   classNameLayout={"mb-6"}
                              />
                              {helpers.values.isNationaliteEtrangere && (
                                   <MySelectGetAllDataFromServerFormField
                                        name={"nationalite"}
                                        label={requiredLabel("Nationalité")}
                                        formikProps={helpers}
                                        validationSchema={schema}
                                        method={"GET"}
                                        endpoint={CONST_API_UTILS_GET_PAYS_ENDPOINT}
                                        payload={{ excluded_country_codes: [CONST_PAYS_CODE_FRANCE] }}
                                        classNameLayout={"mb-6"}
                                        placeholder={"Précisez la nationalité"}
                                   />
                              )}
                              </div>

                              <div className="separator separator-dashed mb-6" />

                              <div style={lockStyleByType(CONST_PERSONNEL_DOCUMENT_TYPE_CV)}>
                              <MyInputFormField name={"residenceAdresse"} label={requiredLabel("Adresse de résidence")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Adresse"} />
                              <MySelectGetAllDataFromServerFormField
                                   name={"residencePays"}
                                   label={requiredLabel("Pays de résidence")}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   method={"GET"}
                                   endpoint={CONST_API_UTILS_GET_PAYS_ENDPOINT}
                                   classNameLayout={"mb-6"}
                                   placeholder={"Pays de résidence"}
                              />
                              {helpers.values.residencePays && (
                                   <div className="row mb-6">
                                        <div className="col-md-6">
                                             {helpers.values.residencePays === CONST_PAYS_ID_FRANCE ? (
                                                  <MySelectSearchDataFromServerFormField
                                                       name={"residenceVilleFrance"}
                                                       label={requiredLabel("Ville de résidence")}
                                                       formikProps={helpers}
                                                       validationSchema={schema}
                                                       method={"GET"}
                                                       endpoint={CONST_API_UTILS_GET_VILLES_URL_ENDPOINT}
                                                       minimumLengthSearch={2}
                                                       placeholder={"Ville"}
                                                       onChangeCallback={(_value, option) => {
                                                            // La ville sélectionnée porte son code postal → renseigne automatiquement le champ.
                                                            const cp = (option as any)?.codePostal
                                                            if (cp) helpers.setFieldValue("residenceCodePostal", cp)
                                                       }}
                                                  />
                                             ) : (
                                                  <MyInputFormField name={"residenceVille"} label={requiredLabel("Ville de résidence")} formikProps={helpers} validationSchema={schema} placeholder={"Ville"} />
                                             )}
                                        </div>
                                        <div className="col-md-6">
                                             <MyInputFormField name={"residenceCodePostal"} label={requiredLabel("Code postal")} formikProps={helpers} validationSchema={schema} placeholder={"Code postal"} inputMode={"numeric"} />
                                        </div>
                                   </div>
                              )}
                              </div>

                              <div className="separator separator-dashed mb-6" />

                              <label className="fs-6 fw-bolder text-gray-900 mb-3 d-block">Personne à contacter en cas d'urgence</label>
                              <div className="row mb-6">
                                   <div className="col-md-6">
                                        <MyInputFormField name={"contactUrgencePrenom"} label={"Prénom"} formikProps={helpers} placeholder={"Prénom"} />
                                   </div>
                                   <div className="col-md-6">
                                        <MyInputFormField name={"contactUrgenceNom"} label={"Nom"} formikProps={helpers} placeholder={"Nom"} />
                                   </div>
                              </div>
                              <div className="row mb-6">
                                   <div className="col-md-6">
                                        <MySelectGetAllDataFromServerFormField
                                             name={"contactUrgenceTelIndicatif"}
                                             label={"Indicatif"}
                                             formikProps={helpers}
                                             method={"GET"}
                                             endpoint={CONST_API_UTILS_GET_INDICATIF_TEL_ENDPOINT}
                                             placeholder={"Indicatif"}
                                             defaultOptions={[{ label: "+33 - France", value: CONST_PAYS_ID_FRANCE }]}
                                        />
                                   </div>
                                   <div className="col-md-6">
                                        <MyInputFormField name={"contactUrgenceTel"} label={"Téléphone"} formikProps={helpers} placeholder={"Téléphone"} inputMode={"numeric"} />
                                   </div>
                              </div>
                              </>
                              )}
                         </div>

                         {/* ================= STEP — Fournisseur (non salarié) ================= */}
                         {!estSalarie && (
                         <div style={{ display: currentKey === STEP_KEY_FOURNISSEUR ? "block" : "none" }}>
                              <MyAlert type={"primary"} classNames={"mb-6"}>
                                   Sélectionnez le fournisseur (société de portage / service / freelance) et son contact.
                              </MyAlert>
                              <MySelectGetAllDataFromServerFormField
                                   name={"fournisseur"}
                                   label={requiredLabel("Fournisseur")}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   method={"GET"}
                                   endpoint={CONST_API_UTILS_GET_FOURNISSEURS_ENDPOINT}
                                   classNameLayout={"mb-6"}
                                   placeholder={"Rechercher un fournisseur"}
                                   onChangeCallback={() => helpers.setFieldValue("fournisseurResponsable", undefined)}
                              />
                              {helpers.values.fournisseur && (
                                   <MySelectGetAllDataFromServerFormField
                                        name={"fournisseurResponsable"}
                                        label={"Contact / responsable fournisseur"}
                                        formikProps={helpers}
                                        method={"GET"}
                                        endpoint={CONST_API_UTILS_GET_FOURNISSEURS_RESP_ENDPOINT}
                                        payload={{ fournisseur: helpers.values.fournisseur }}
                                        classNameLayout={"mb-6"}
                                        placeholder={"Contact du fournisseur"}
                                   />
                              )}
                         </div>
                         )}

                         {/* ================= STEP — Poste & organisation ================= */}
                         <div style={{ display: currentKey === STEP_KEY_POSTE ? "block" : "none" }}>
                              {estSalarie ? (
                                   <>
                                        {/* Contrat d'abord, puis Statut. */}
                                        <MySelectFormField name={"contrat"} label={requiredLabel("Contrat")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Contrat"} options={CONST_PERSONNEL_CONTRATS_OPTIONS_FOR_SELECT2.filter((o: any) => o.value !== CONTRAT_NON_SALARIE_VALUE)} />
                                        <MySelectFormField name={"statut"} label={requiredLabel("Statut")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Statut"} options={CONST_PERSONNEL_STATUTS_OPTIONS_FOR_SELECT2.filter((o: any) => o.value !== STATUT_NON_SALARIE)} />
                                   </>
                              ) : (
                                   <div className="row mb-6">
                                        <div className="col-md-6">
                                             <label className="form-label">Statut</label>
                                             <input className="form-control form-control-solid" value="Non salarié" disabled readOnly />
                                        </div>
                                        <div className="col-md-6">
                                             <label className="form-label">Contrat</label>
                                             <input className="form-control form-control-solid" value="Contrat non salarié" disabled readOnly />
                                        </div>
                                   </div>
                              )}
                              <MySelectGetAllDataFromServerFormField
                                   name={"poste"}
                                   label={"Métier"}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   method={"GET"}
                                   endpoint={CONST_API_UTILS_GET_METIERS_PERSONNEL_INTERNE_URL_ENDPOINT}
                                   // Catégories de métiers non proposées à l'embauche staff (ex : Direction).
                                   payload={{ exclude: ["CATEGORIE_DG"] }}
                                   classNameLayout={"mb-6"}
                                   placeholder={"Métier"}
                                   onChangeCallback={(_value: any, option: any) => helpers.setFieldValue("posteCategorie", option?.categorie ?? null)}
                              />
                              <MySelectGetAllDataFromServerFormField name={"agence"} label={"Lieu de travail"} formikProps={helpers} validationSchema={schema} method={"GET"} endpoint={CONST_API_UTILS_GET_AGENCES_ENDPOINT} classNameLayout={"mb-6"} placeholder={"Lieu de travail"} />
                              <MySelectGetAllDataFromServerFormField name={"entite"} label={"Entité de rattachement"} formikProps={helpers} validationSchema={schema} method={"GET"} endpoint={CONST_API_UTILS_GET_ENTITES_ENDPOINT} classNameLayout={"mb-6"} placeholder={"Entité de rattachement"} />
                              <MySelectGetAllDataFromServerFormField name={"entiteFacturation"} label={"Entité de facturation"} formikProps={helpers} validationSchema={schema} method={"GET"} endpoint={CONST_API_UTILS_GET_ENTITES_ENDPOINT} classNameLayout={"mb-6"} placeholder={"Entité de facturation"} />
                              <MySelectGetAllDataFromServerFormField
                                   name={"responsable"}
                                   label={"Responsable direct"}
                                   formikProps={helpers}
                                   validationSchema={schema}
                                   method={"GET"}
                                   endpoint={CONST_API_UTILS_GET_ACTIVE_PERSONNELS_ENDPOINT}
                                   defaultOptions={connectedPersonnelOption}
                                   classNameLayout={"mb-2"}
                                   placeholder={"Responsable direct"}
                              />
                              <div className="form-text mb-6">Par défaut : vous (le créateur). Modifiable.</div>
                              <MyDateDayMonthYearFormField name={"dateEntree"} label={"Date d'entrée"} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Date d'entrée"} />
                              <MyInputFormField
                                   name={"linkedinUrl"}
                                   label={helpers.values.posteCategorie === CATEGORIE_COMMERCIAL ? requiredLabel("Lien du profil LinkedIn") : "Lien du profil LinkedIn"}
                                   formikProps={helpers}
                                   classNameLayout={"mb-2"}
                                   placeholder={"https://www.linkedin.com/in/…"}
                              />
                              {helpers.values.posteCategorie === CATEGORIE_COMMERCIAL && (
                                   <div className="form-text mb-6">
                                        <i className="fas fa-circle-info text-primary me-1" />
                                        Requis pour un métier <strong>commercial</strong> : le profil LinkedIn remplace la carte de visite papier, partagée via la <strong>carte NFC</strong> du collaborateur.
                                   </div>
                              )}

                              <div className="separator separator-dashed mb-6" />

                              {/* Rémunération : salaire brut (salarié) ou taux journalier HT (non salarié). */}
                              {estSalarie ? (
                                   <MyInputFormField name={"salaireBrutMensuel"} label={requiredLabel("Salaire brut mensuel (€)")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Salaire brut mensuel"} type={"number"} inputMode={"numeric"} />
                              ) : (
                                   <MyInputFormField name={"tauxJournalierHt"} label={requiredLabel("Taux journalier HT (€)")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Taux journalier HT"} type={"number"} inputMode={"numeric"} />
                              )}
                         </div>

                         {/* ================= STEP — Temps & activité (salarié uniquement) ================= */}
                         {estSalarie && (
                         <div style={{ display: currentKey === STEP_KEY_TEMPS ? "block" : "none" }}>
                              <MyInputFormField name={"heuresTravail"} label={requiredLabel("Heures travail")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Heures travail"} type={"number"} inputMode={"decimal"} />
                              <MyInputFormField name={"heuresSupp"} label={requiredLabel("Heures supp.")} formikProps={helpers} validationSchema={schema} classNameLayout={"mb-6"} placeholder={"Heures supp."} type={"number"} inputMode={"decimal"} />
                              <MySelectFormField
                                   name={"optionLignesCra"}
                                   label={"Options CRA"}
                                   formikProps={helpers}
                                   classNameLayout={"mb-2"}
                                   placeholder={"Options CRA"}
                                   isMulti
                                   options={[
                                        { label: "Télétravail (TT)", value: CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_TT },
                                        { label: "École", value: CONST_PERSONNEL_CRA_DETAILS_HEURE_TYPE_ECOLE },
                                   ]}
                              />
                              <div className="form-text mb-6">
                                   Types de lignes que le collaborateur pourra saisir dans son CRA (compte rendu d'activité) en plus des heures travaillées : <strong>Télétravail</strong> et/ou <strong>École</strong> (formation/alternance).
                              </div>
                         </div>
                         )}

                         {/* ================= STEP — Documents ================= */}
                         <div style={{ display: currentKey === STEP_KEY_DOCS ? "block" : "none" }}>
                              {demandeId ? (
                                   <DocumentsStep
                                        demandeId={demandeId}
                                        initialDocuments={documents}
                                        onDocumentsChange={setDocuments}
                                        requireTitreSejour={estSalarie && !!helpers.values.isNationaliteEtrangere}
                                        estSalarie={estSalarie}
                                        initialSansDiplome={sansDiplome}
                                        fournisseurId={helpers.values.fournisseur}
                                        canAddContrat={
                                             estSalarie &&
                                             (currentUser?.roles ?? []).some(r => [CONST_USER_ROLE_DAF, CONST_USER_ROLE_RESPONSABLE_RH, CONST_USER_ROLE_RH].includes(r)) &&
                                             // RH validant un salarié (VALIDE_DG), OU créateur RH remplissant sa demande (brouillon / rectification) :
                                             // dans ce dernier cas le contrat est obligatoire dès la soumission (pas d'étape RH).
                                             ["ETAT_VALIDE_DG", "ETAT_BROUILLON", "ETAT_RECTIF_PAR_DG", "ETAT_RECTIF_PAR_HR"].includes(demandeEtat ?? "")
                                        }
                                        contratRequired={
                                             estSalarie &&
                                             ["ETAT_BROUILLON", "ETAT_RECTIF_PAR_DG", "ETAT_RECTIF_PAR_HR"].includes(demandeEtat ?? "") &&
                                             (currentUser?.roles ?? []).some(r => [CONST_USER_ROLE_DAF, CONST_USER_ROLE_RESPONSABLE_RH, CONST_USER_ROLE_RH].includes(r))
                                        }
                                   />
                              ) : (
                                   <MyAlert type={"warning"} isDismissible={false}>
                                        <>Veuillez d'abord compléter l'étape « Identité & contact » pour pouvoir ajouter des documents.</>
                                   </MyAlert>
                              )}
                         </div>

                         {/* Modales d'ajout fournisseur / contact fournisseur (non salarié). */}
                         {isAddingFournisseur && (
                              <MyModal title={"Nouveau fournisseur"} show={true} onCloseCallback={() => setIsAddingFournisseur(false)}>
                                   <AddFournisseurForm callback={() => setIsAddingFournisseur(false)} />
                              </MyModal>
                         )}
                         {isAddingFournisseurResp && (
                              <MyModal title={"Nouveau contact fournisseur"} show={true} onCloseCallback={() => setIsAddingFournisseurResp(false)}>
                                   <AddResponsableFournisseurForm
                                        onSubmitCallback={() => {
                                             toast.success("Le contact a bien été ajouté")
                                             setIsAddingFournisseurResp(false)
                                        }}
                                        defaultFournisseurFieldLabel={selectedFournisseurLabel}
                                        defaultFournisseurFieldValue={helpers.values.fournisseur}
                                        isFournisseurFieldReadOnly={true}
                                   />
                              </MyModal>
                         )}

                         <div className="separator bg-primary my-5" />

                         {/* Navigation */}
                         <div className={"d-flex justify-content-between"}>
                              <button
                                   type="button"
                                   className={"btn btn-sm btn-light-primary d-inline-flex align-items-center"}
                                   onClick={() => goPrevious(helpers)}
                                   disabled={step === 0 || saving}
                              >
                                   <i className="fas fa-arrow-left me-1" /> Précédent
                              </button>

                              {step < steps.length - 1 ? (
                                   <button
                                        type="button"
                                        className={"btn btn-sm btn-primary d-inline-flex align-items-center"}
                                        onClick={() => saveStepAndNext(helpers)}
                                        disabled={saving}
                                   >
                                        {saving ? <MySimpleSpinner size={"sm"} /> : <>Enregistrer et suivant <i className="fas fa-arrow-right ms-1" /></>}
                                   </button>
                              ) : (
                                   <button type="button" className={"btn btn-sm btn-success d-inline-flex align-items-center"} onClick={finish} disabled={saving}>
                                        Terminer <i className="fas fa-check ms-1" />
                                   </button>
                              )}
                         </div>
                         </div>
                    </Form>
                                   </MyCard.Body>
                              </MyCard>
                         </div>
                    </div>
                    </>
                    )
               }}
          </Formik>
     )
}

export default FormCreate
